import styled from '@emotion/styled'

export const ProductCount = styled.span`
  font: inherit;
`
